<div *ngIf="initialized" class="flex flex-column gap-3 p-3">

    <!-- Template Data -->
    <div class="grid">
        <div class="col-12">
            <mvs-widget
                *ngIf="templateDataWidget"
                [widgetData]="templateDataWidget">
            </mvs-widget>
        </div>
    </div>

    <!-- Template Lanes -->
    <div class="grid">
        <div class="col-12">
            <mvs-widget
                *ngIf="laneWidget"
                [widgetData]="laneWidget">
            </mvs-widget>
        </div>
    </div>

</div>

<!-- Loading State -->
<div *ngIf="!initialized" class="flex flex-column gap-3 p-3">
    <p-skeleton height="4rem" class="mb-3"></p-skeleton>
    <p-skeleton height="20rem"></p-skeleton>
</div>
